/**
 * Admin session token.
 *
 * The panel used to keep only a boolean in redux and send nothing with its requests,
 * which left every /api/admin route open. The token issued by the login endpoint now
 * goes on each request, and the boolean is only ever a mirror of whether one is held.
 */
const TOKEN_KEY = "adminToken";

/** Fired when the API rejects the token, so the UI can drop back to the login screen. */
export const ADMIN_SESSION_ENDED = "admin-session-ended";

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY) || "";

export const setAdminToken = (token) => localStorage.setItem(TOKEN_KEY, token);

export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);

export const endAdminSession = () => {
  clearAdminToken();
  window.dispatchEvent(new Event(ADMIN_SESSION_ENDED));
};
